export const WHITELIST_OF_CATEGORY_SLUGS = [
  'pages',
  'rules',
  'faq',
  'steam',
  'hypertask',
  'squad',
  'pickem',
  'fantasy'
]
